import { useTranslation } from 'react-i18next';
import { reduxForm } from 'redux-form';

import { Toggle, StyledField, ErrorMsg } from 'libs/form';
import { ButtonContainer, Submit } from 'libs/ui';
import { Block } from './zones-form-form.styled';

const ZonesFormFormInner = (props) => {
  const { handleSubmit, submitting, error, limits, old } = props;
  const { t } = useTranslation();

  /**
   * get zone inputs
   * @returns
   */
  const getZonesEl = () => {
    return limits.map((el, idx) => {
      return <Toggle key={idx} className="green-red lk" type="toggle" label={el.name} name={`zones.${el.id}`} />;
    });
  };

  const zonesEl = getZonesEl();

  return (
    <form onSubmit={handleSubmit}>
      <ErrorMsg theme="dark" message={error} />
      {!old && (
        <Block>
          <Toggle className="green-red lk" type="toggle" label={t('clients.Валидация')} name="validation" />
          <Toggle className="green-red lk" type="toggle" label={t('clients.Заявки')} name="orders" />
          <Toggle className="green-red lk" type="toggle" label={t('clients.Свободный проезд')} name="excemption" />
        </Block>
      )}
      {zonesEl}
      <StyledField type="text" label={t('form.Минимальная сумма валидации')} name="min_validation_limit" className="medium-field" mask={{ suffix: t('form.руб') }} maxLength={16} />
      <StyledField type="text" label={t('form.Максимальная сумма валидации')} name="validation_limit" className="medium-field" mask={{ suffix: t('form.руб') }} maxLength={16} />

      <br />
      <ButtonContainer>
        <Submit disabled={submitting} />
      </ButtonContainer>
    </form>
  );
};

export const ZonesFormForm = reduxForm({
  form: 'ZonesForm',
})(ZonesFormFormInner);
